import { Component, ViewEncapsulation } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { HttpClient } from "@angular/common/http";
import { Router } from '@angular/router';
import { GlobalComponent } from 'src/app/global/global.component';
import { ConfigurationService } from 'src/app/configuration.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { LoginService } from './login.service';
import { AuthenticationRequestBo } from './login.modal';
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class LoginComponent {
  private onDestroy$: Subject<void> = new Subject<void>();
  SaveAuthRequest: AuthenticationRequestBo = new AuthenticationRequestBo();

  LoginMessageErr: string = "";
  LoginForm: FormGroup;
  submitted = false;
  warning: boolean;
  status: number;
  statusERR: string = "";
  uname: any = '';
  aCode: any = '';
  role: any = "";
  isenable: boolean = false;
  Email: any;
  WebPassword: any;
  agencycode: any;
  userSelectedRole: any = "";
  versioncontrolnumber: any;
  RoleList: any = [];

  source: string = '/assets/img/Abstract1.jpg';
  configuration: any;
  Password: any;
  show_pass: boolean = false;

  constructor(public http: HttpClient, public Loginservice: LoginService, private formBuilder: FormBuilder,
    public router: Router,
    public global: GlobalComponent, public toasterService: ToastrService,
    public configurationservice: ConfigurationService) {
    this.configuration = this.configurationservice.getConfiguration();
    this.LoginForm = this.formBuilder.group({
      Email: ['', Validators.required],
      WebPassword: ['', Validators.required],
      agencycode: ['', Validators.required],
    });
  }

  ngOnInit() {
    this.global.authtoken = '';
    
    localStorage.clear();
    this.versioncontrolnumber = this.configuration.uiVresion;
    this.SaveAuthRequest.type = "Admin"
    this.show_pass = false;
    this.Password = 'password'
  }
  //////////////////////////////////////////////
  forgotpassword() {
    this.router.navigateByUrl("/forgot-password")
  }
  // New Code/
  //setMenudata.........................................................................................................
  setMenudata(data) {
    let menu: any = []
    let i: number = 1;
    data.forEach(element => {
      let temp: any = {}
      temp.id = i;
      temp.title = element.title;
      temp.routerLink = element.link;
      temp.href = null;
      temp.icon = element.icon;
      temp.target = null;
      temp.parentId = 0;
      if (element.children != null && element.children.length > 0) {
        let j: number = i + 1;
        element.children.forEach(element => {
          let submenu: any = {}
          submenu.id = j;
          submenu.title = element.title;
          submenu.routerLink = element.link;
          submenu.href = null;
          submenu.icon = element.icon;
          submenu.target = null;
          submenu.hasSubMenu = false;
          submenu.parentId = i;
          menu.push(submenu);
          j++;
        });
        i = j - 1;
        temp.hasSubMenu = true;
      }
      else {
        temp.hasSubMenu = false;
      }
      menu.push(temp);
      i++;
    });
    this.global.AddMenuItems(data);
    this.global.sideMenuItems = menu;
    localStorage.setItem("fms_menulist", JSON.stringify(this.global.sideMenuItems));
    let val = localStorage.getItem('fms_role');
    if (this.SaveAuthRequest.roleId != val) {
      localStorage.setItem('fms_role', this.SaveAuthRequest.roleId);
      this.global.userSelectedRole = this.SaveAuthRequest.roleId;

    }
    if (data.agencyOverallList != null) {
      this.global.globalAgencyDropDown = data.agencyOverallList;
      this.global.ngAgencyDropDown = this.global.globalAgencyDropDown;
      this.global.ngAgencyDropDown.forEach(a => a.id = a.id.toString());
      this.global.globalAgencyDropdown = this.global.globalAgencyId == 0 ? '' : this.global.globalAgencyId.toString();
    }

    this.router.navigateByUrl("/operational-dashboard");
    this.toasterService.success('Login Successful');
  }
  //......................................................getSideMenus..............................................
  getSideMenus() {
    this.Loginservice.getSideMenus().subscribe((data: any) => {
      this.setMenudata(data);
      this.global.AddMenuItems(data);
      localStorage.setItem("fms_sidebars", JSON.stringify(data));
    },
      (err: any) => {
        if (err) {
          this.toasterService.error(err, 'Error'), 8000;
        }
      })
  }
  // .................................getWebsiteUserDetails.................................
  getWebsiteUserDetails() {
    this.Loginservice.getWebsiteUserDetails().subscribe((data: any) => {
      localStorage.setItem("fms_agencydetails", JSON.stringify(data));
      this.global.getAgencyDetails(data);
      this.global.userID = data.userId;
      this.global.globalAgencyId = data.agencyId;

      if (this.global.userID == "00000000-0000-0000-0000-000000000000" || this.global.userID == null || this.global.userID == undefined) {
        this.global.userRoleDropDown.length = 0;

      }
      else if (this.global.userID != "00000000-0000-0000-0000-000000000000" && this.global.userID != null && this.global.userID != undefined) {
        this.global.globalAgencyDropDown.length = 0;
        this.global.globalAgencyDropdown = [];
      }
      let value = data.roleId;
      localStorage.setItem('fms_role', value);
      this.global.roleId = data.roleId;
      this.SaveAuthRequest.roleId = value;
      this.global.userSelectedRole = this.SaveAuthRequest.roleId;
    },
      (err: any) => {
        if (err) {
          this.toasterService.error(err, 'Error'), 8000;
        }
      })
  }
  //...................................LoginDataFunction........................................
  LoginDataFunction() {
    this.global.loading = true;
    this.getlogin().then((res: any) => {
      let data = res;
      this.global.OnboardingLoginType = "agencyLogin";
      this.global.LoginUserType = "Admin";
      localStorage.setItem("fms_checkType", this.global.OnboardingLoginType);
      this.global.refreshTokenString=data.refreshToken;
      localStorage.setItem("fms_refreshtoken ", JSON.stringify(data.refreshToken));
      if (this.SaveAuthRequest.agencyCode != null && this.SaveAuthRequest.agencyCode != undefined && this.SaveAuthRequest.agencyCode != '') {
        let converttoUpper = this.SaveAuthRequest.agencyCode.toUpperCase();
        localStorage.setItem("fms_agencyCode", converttoUpper);
        this.global.agencyCode = converttoUpper;
      }
      if (this.SaveAuthRequest.userName != null && this.SaveAuthRequest.userName != undefined && this.SaveAuthRequest.userName != '') {
        let converttoUpper = this.SaveAuthRequest.userName.toUpperCase();
        localStorage.setItem("fms_Username", converttoUpper);
        this.global.username = converttoUpper;
      }

      if (data.accessToken != null) {
        this.global.scheduleRefresh();
        console.log(data,"daa")
        if (data.roleName != null) {

          localStorage.setItem("fms_roles", data.roleName);
          this.global.roles = data.roleName;
        }
        this.getWebsiteUserDetails()
        setTimeout(() => {
          this.getSideMenus();
        }, 400);

      }
      else {
        this.RoleList = data.roles;
        this.global.userRoleDropDown = data.roles;
        document.getElementById("openmultilogin").click()
      }
    }).
      catch((err) => {
        this.global.loading = false;
        this.warning = true;
        this.status = err.error;
        setTimeout(function () {
          this.warning = false;
        }.bind(this), 6000)
        this.global.loading = false
      })
  }
  //.............................getlogin............................................................
  getlogin() {
    return new Promise((resolve, reject) => {
      let loginPayLoad: AuthenticationRequestBo = JSON.parse(JSON.stringify(this.SaveAuthRequest));
      this.Loginservice.CheckLoginAuthentication(loginPayLoad).pipe(takeUntil(this.onDestroy$)).subscribe(
        (data: any) => {
          resolve(data);
          this.global.assignToken(data);
          localStorage.setItem("fms_login", JSON.stringify(data));
          this.global.refreshTokenString=data.refreshToken;
          localStorage.setItem("fms_refreshtoken ", JSON.stringify(data.refreshToken));

        }, (err: any) => {
          reject(err)
          this.warning = true;
          this.statusERR = err;
          this.toasterService.error(err, "Error"), 8000;
          if (this.statusERR != "") {
            setTimeout(function () {
              this.statusERR = "";
            }.bind(this), 6000)
          }
        });
    });
  }

  showPass() {
    this.show_pass = !this.show_pass;
    let val = document.getElementById('bi-ico');
    return (this.show_pass ? this.Password = 'text' : this.Password = 'password');

  }

  
  public ngOnDestroy(): void {
    this.onDestroy$.next();
  }
}
